import { DEMO_PRESET_PERSONS, PersonTypes, PersonsV3 } from '@frontend/api-person';

export const DEMO_PERSON = DEMO_PRESET_PERSONS['jane-doe'];
export const DEMO_PERSON_V3 = Object.assign({}, PersonsV3.PersonHelpers.convertPersonV3ToPerson(DEMO_PERSON), {
  SourceType: PersonTypes.PersonSourceType.Integration,
});
